import { isBussinessUser } from "./BizUtils";

export const VAR_SRC_DEST_CODES = 'm_v2';
export const VAR_SRC_DEST = 'm_c3';
export const VAR_START_DATE = 'm_c4';
export const VAR_END_DATE = 'm_v5';
export const VAR_DURATION = 'm_v6';
export const VAR_TRIP_DATE = 'm_v7';
export const VAR_TRIP_TYPE = 'm_v9';
export const VAR_SEARCH_PAX = 'm_v11';
export const VAR_PAGE_NAME = 'm_v15';
export const PROP_61 = 'm_c61';
export const VAR_PREVIOUS_PAGENAME = 'm_c23';
export const VAR_LOB_KEY = 'm_c24';
export const VAR_AP = 'm_c7'; // Advance Purchase
export const VAR_ERROR_KEY = 'm_v22';
export const VAR_BUSINESS_KEY = 'm_v24';
export const VAR_PRODUCT_ID = 'm_v40';
export const VAR_PRICE = 'm_v46';
export const VAR_CAMPAIGN = 'm_v81';
export const VAR_REFERRER = 'm_v71';
export const VAR_JS_VERSION = 'm_list2';
export const VAR_CHANNEL = 'm_ch';
export const VAR_USER_LOGIN_STATUS = 'm_v39';
export const VAR_USER_MOBILE_NUMBER = 'm_v35';
export const VAR_USER_EMAIL = 'm_v34';
export const VAR_BUS_OPERATOR = 'm_v36';
export const VAR_BUS_RATING = 'm_v42';
export const VAR_NUMBER_SEATS_SELECTED = 'm_v27';
export const VAR_PREVIOUS_PAGE_FOR_TY = 'm_v23';
export const VAR_NUMBER_SEARCH_RESULTS = 'm_v13';
export const PURCHASE_ID = 'm_v16';
export const PURCHASE_KEY = 'purchaseID';
export const EVAR_71 = 'm_v71';

export const PROP_54 = 'm_c54';
export const EVAR_47 = 'm_v47';

const isThankYouPageSuccess = (pagename = '') => (pagename.toLowerCase().includes('thank') && pagename.toLowerCase().includes('success'));
const hasPurchaseString = (str = '') => str.includes('purchase');
const isB2b = isBussinessUser();

const _trackStateSafe = (pagename, params) => {
  try {
    const { s } = window;
    const isThankYou = isThankYouPageSuccess(pagename);
    if (isThankYou && !hasPurchaseString(s.events)) {
      if (s.events) {
        s.events = s.events + ',purchase';
      } else {
        s.events = 'purchase';
      }
    }

    const { isLoad } = params;
    s.linkTrackVars = 'channel,eVar1,eVar15,eVar34,prop24,eVar75';
    const keys = Object.keys(params);
    keys.filter((key) => key !== 'isLoad').forEach((key) => {
      const newKey = key.replace('m_c', 'prop').replace('m_v', 'eVar').replace('m_', '');
      s.linkTrackVars += `,${newKey}`;
      s[ newKey ] = params[ key ];
    });
    s.eVar15 = pagename;
    s.pageName = pagename;
    s.eVar18 = s.getVisitNum();
    s.channel = 'dom rails funnel' + (isB2b ? '|corporate' : '');
    s.eVar1 = navigator.userAgent;

    const sCode = isLoad ? s.t(this, 'o', pagename) : s.tl(this, 'o', pagename);
    if (sCode) {
      document.write(sCode);
    }
  } catch (e) {
    // ignore
    console.error('Error', e);
  }
};

export const trackOmniture = (pagename, data) => {
  _trackStateSafe(pagename, _addBuildInfoTrackingParams(data));
};

export const trackPageVisits = (pageName, params) => {
  params.pagename = pageName;
  params.m_v15 = pageName;
  console.log('Omniture PageVisit', JSON.stringify(params));
  trackOmniture(pageName, params);
};

export function trackClickEventProp61(pageName, eventName) {
  const params = {
    [PROP_61]: eventName
  };
  trackOmniture(pageName, params);
}

export const trackClick = (pageName, clickSource, params) => {
  params.pagename = pageName;
  params.m_c50 = clickSource;
  console.log('Omniture Click', JSON.stringify(params));
  trackOmniture(pageName, params);
};

export const trackClickAndPage = (pageName, clickSource, params) => {
  params.pagename = pageName;
  params.m_c50 = clickSource;
  params.m_v15 = pageName;
  console.log('Omniture Click', JSON.stringify(params));
  trackOmniture(pageName, params);
};

export const trackClickEvent = (pageName, clickEvent, params = {}) => {
  params.pageName = pageName;
  params.m_v15 = pageName;
  params.m_c54 = clickEvent;
  console.log('Omniture Click Event', JSON.stringify(params));
  trackOmniture(pageName, params);
};

// NEXT VERSION SHOULD BE 9.0
// NEXT CODE PUSH VERSION SHOULD BE 7.1
export const JS_VERSION = '8.0';

const _addBuildInfoTrackingParams = (data) => ({
  ...data,
  [ VAR_JS_VERSION ]: JS_VERSION,
});
